import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CheckboxComponent } from '../pdf-tool-manage/common/checkbox/checkbox-component';
import {
  editPagesSelected,
  extractButtonText,
  selectFinalPDFs,
  selectMergeExtractedPages,
  selectPages,
  selectPagesInputVisible,
  selectSelectedPDF,
  toggleMergeExtractedPages,
  toggleSelectPagesButton,
} from '../pdf-tool-manage/pdf-slice';
import { useAppDispatch } from '../store/store';
import { useDebouncedCallback } from 'use-debounce';
import MultiRange from 'multi-integer-range';

export const ExtractPanel: React.FC<{}> = () => {
  const [inputRange, setInputRange] = useState('');
  const selectExtractButtonText = useSelector(extractButtonText);
  const getSelectPagesInputVisible = useSelector(selectPagesInputVisible);
  const getSelectMergeExtractedPages = useSelector(selectMergeExtractedPages);
  const getSelectPages = useSelector(selectPages);
  const getSelectedPDF = useSelector(selectSelectedPDF);
  const selectedPagesNumber = useSelector(selectFinalPDFs);

  const dispatch = useAppDispatch();

  const debounced = useDebouncedCallback((value) => {
    try {
      const pp = new MultiRange(value);
      // Filter out page numbers greater than all pages in PDF document
      const pagesIndexes = pp
        .toArray()
        .filter((el) => el > 0 && el <= getSelectedPDF.pages);
      dispatch(editPagesSelected(pagesIndexes));
    } catch (err) {}
  }, 1000);

  const handleSelectPagesButtonClick = (e) => {
    dispatch(toggleSelectPagesButton());
  };

  const handleMergeCheckbox = (e) => {
    dispatch(toggleMergeExtractedPages());
  };

  const onRangeInputChange = (value: any) => {
    setInputRange(value);
    debounced(value);
  };

  useEffect(() => {
    const selectedIndexes = [];
    Object.keys(getSelectPages).forEach((k) => {
      if (getSelectPages[k].selected) {
        selectedIndexes.push(parseInt(k));
      }
    });
    const pagesRange = new MultiRange(selectedIndexes);
    setInputRange(pagesRange.toString());
  }, [getSelectPages]);

  return (
    <div className="pdf-tool-manage__right__extract-pages-container">
      <div className="pdf-tool-manage__right__description">
        Every selected page of this PDF file will be converted in one separated
        PDF file.
        <div className="pdf-tool-manage__right__files-text">
          <span className="pdf-tool-manage__right__bold">{`${selectedPagesNumber} PDF files`}</span>{' '}
          will be created.
        </div>
      </div>
      <div className="pdf-tool-manage__right__select-link">
        <button onClick={(e) => handleSelectPagesButtonClick(e)}>
          {selectExtractButtonText}
        </button>
      </div>
      {getSelectPagesInputVisible ? (
        <div className="pdf-tool-manage__right__extract-container">
          <div className="pdf-tool-manage__right__extract-input-container">
            <input
              type="text"
              className="pdf-tool-manage__right__extract-input"
              placeholder="example: 1,5-8"
              value={inputRange}
              onChange={(e) => onRangeInputChange(e.target.value)}
            />
          </div>
          <div className="pdf-tool-manage__right__extract-checkbox">
            <CheckboxComponent
              checked={getSelectMergeExtractedPages}
              onChange={(e) => handleMergeCheckbox(e)}
              labelText="Merge extracted pages in one file"
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};
